import { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { applyTheme, getInitialTheme, isDarkTheme, persistTheme } from '../theme/tokens';

export const useTheme = () => {
  const [themeMode, setThemeMode] = useState(getInitialTheme);

  useLayoutEffect(() => {
    applyTheme(themeMode);
    persistTheme(themeMode);
  }, [themeMode]);

  const toggleTheme = useCallback(() => {
    setThemeMode((prev) => prev === 'dark' ? 'light' : 'dark');
  }, []);

  const theme = useMemo(() => ({
    mode: themeMode,
    isDark: isDarkTheme(themeMode),
    setMode: setThemeMode,
    toggle: toggleTheme
  }), [themeMode, toggleTheme]);

  return theme;
};
